<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EpfX4r/tc-custom/9781459201859.jpg?1699984631419" alt="This image is the cover for the book Breaking the Sheikh's Rules"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breaking the Sheikh's Rules
      </h1>
      <p class="bookDescription body article font2">
        <b>An innocent Irish horse trainer discovers unbridled passion with an imperious sheikh in this sexy international romance.</b><br/><br/>Iseult thought she would live out her days on the bucolic Irish countryside. But that all changes when Sheikh Nadim bought her family’s stud farm. As part of the deal, Iseult must accompany Nadim back to his desert kingdom to work at his royal stables. . . . <br/><br/>Nadim’s arrogance enrages Iseult . . . but his irresistible appeal also inspires a more unwelcome, unfamiliar feeling: <i>desire.</i> Drawn into Nadim’s sensual world, Iseult feels like a beautiful, confident woman for the first time. But she must remember the sheikh’s cast-iron rule. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Abby Green
      </h2>
      
      <p class="authorDescription body article">Abby Green spent her teens reading Mills &amp; Boon romances. She then spent many years working in the Film and TV industry as an Assistant Director. One day while standing outside an actor&#39;s trailer in the rain, she thought:&#160;<I>there has to be more than this.&#160;</I>So she sent off a partial to Harlequin Mills &amp; Boon. After many rewrites, they accepted her first book and an author was born. She lives in Dublin, Ireland and you can find out more here: www.abby-green.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e746d17